import React, { useEffect, useState } from 'react';
import HomePage from './Pages/HomePage/HomePage';
import { MemoryRouter, Route } from 'react-router-dom';
import { withRouter, RouteComponentProps } from 'react-router';
import Helmet from 'react-helmet';
import './EnviziPriceEstimator.scss';
import { Assessment } from './Pages/Assessment/Assesment';
import { getDataSource } from '../utility';
import AppProvider from '../hooks/AppProvider';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { useBPName } from 'src/common/hooks/widgets/useBPName';
import { UT30Envzi, tileInfo } from '../constant/spread';
import { useAppContext } from '../hooks/AppContext';

export interface EnviziPriceEstimatorProps {
  langCode: string;
  element: Element;
  countryToTest: string;
  test: boolean;
}

const EnviziPriceEstimator = ({
  langCode,
  element,
  countryToTest,
  test,
}: EnviziPriceEstimatorProps) => {
  const source =
    window.localStorage.getItem('debugSource') ?? getDataSource(element);
  return (
    <AppProvider source={source}>
      <AppRouter
        langCode={langCode}
        element={element}
        countryToTest={countryToTest}
        test={test}
      />
    </AppProvider>
  );
};

const AppRouter = ({
  langCode,
  countryToTest,
  test,
}: EnviziPriceEstimatorProps) => {
  return (
    <MemoryRouter initialEntries={['/', '/input']}>
      <ContentRoute
        langCode={langCode}
        countryToTest={countryToTest}
        test={test}
      />
    </MemoryRouter>
  );
};

type contentProps = RouteComponentProps & {
  langCode: string;
  countryToTest: string;
  test: boolean;
};

const Content = ({ langCode, countryToTest, test }: contentProps) => {
  const { bpName, companyId, logo, desc } = useBPName(UT30Envzi, true);
  const [tileValueSelected, setTileValueSelected] = useState(tileInfo.est);
  const { appAction } = useAppContext();

  useEffect(() => {
    appAction({
      type: 'reset',
      answerId: '',
      answerValue: false,
    });
  }, []);

  return (
    <div className="envizi_widget widget-styles">
      <Helmet>
        <script
          type="application/javascript"
          src={`https://www.ibm.com/account/ibmidutil/widget/js/loader.js`}
        ></script>
        <script
          type="application/javascript"
          src={`https://www.ibm.com/account/ibmidutil/widget/js/main.js`}
        ></script>
      </Helmet>
      {bpName ? (
        <BusinessPartner bpName={bpName} logo={logo} desc={desc} />
      ) : null}
      <Route
        exact
        path="/"
        render={() => (
          <HomePage
            tileValue={tileValueSelected}
            setTileValue={setTileValueSelected}
            langCode={langCode}
            test={test}
            countryToTest={countryToTest}
          />
        )}
      />
      <Route
        path="/input"
        render={(props) => (
          <Assessment
            bpName={bpName}
            logo={logo}
            companyId={companyId}
            langCode={langCode}
            tileValue={tileValueSelected}
            setTileValue={setTileValueSelected}
            test={test}
            countryToTest={countryToTest}
            {...props}
          />
        )}
      />
    </div>
  );
};

const ContentRoute = withRouter(Content);

export default EnviziPriceEstimator;
